<template>
  <footer>
    <div class="information">
      <div class="company">
        <span>
          <img src="../../assets/img/company.png"/>南京跨链科技有限公司
        </span>

      </div>

      <div class="tel">
        <span>
        <img src="../../assets/img/tel.png"/>电话：025-86201301
      </span>
      </div>
      <div class="email">
        <span>
          <img src="../../assets/img/email.png"/>邮箱：info@blocklinker.com
        </span>

      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "v-footer"
  }
</script>

<style lang="less" scoped>
  footer {
    position: relative;
    width: 100%;
    background: url("../../assets/img/footer-bg.jpg");
    background-size: 100% 100%;
    .information {
      position: absolute;
      width: 80%;
      min-width: 1180px;
      height: 100%;
      display: flex;
      left: 50%;
      top: -50%;
      transform: translateX(-50%);
      justify-content: space-between;
      background: white;
      box-shadow: 0px 0px 40px rgba(111, 111, 111, 0.04);
      div {
        position: relative;
        flex: 1;
        text-align: center;
        font-size: 1.5rem;
        img {
          vertical-align: middle;
          margin-right: 14px;
        }
        span {
          display: inline-block;
          width: 100%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          text-align: center;
        }
      }
      .company {
        padding-left: 48px;
        text-align: left;
      }
      .email {
        padding-right: 48px;
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/plug/VFooter.vue